export default __webpack_public_path__ + "static/media/Plattform_AO.00ec9370.png";